import { InvoiceResponse } from '@/api/backend/types';

export const getInvoiceResponseForPaymentTask = (
  taskDefinitionKey: string | undefined,
  formVariables: { [key: string]: unknown } | undefined,
): InvoiceResponse | null => {
  const paymentNumber = taskDefinitionKey?.match(/^payment-(\d+)$/)?.[1];

  if (!paymentNumber || !formVariables) {
    return null;
  }

  const invoiceResponse = formVariables[`invoiceResponse${paymentNumber}`];

  if (
    invoiceResponse !== null &&
    invoiceResponse !== undefined &&
    typeof invoiceResponse === 'object' &&
    'invoiceNumber' in invoiceResponse &&
    typeof (invoiceResponse as { invoiceNumber: unknown }).invoiceNumber === 'string'
  ) {
    return invoiceResponse as InvoiceResponse;
  }

  return null;
};
